import { IVoiceTimer } from "@interfaces/voicecall/voicecall";
import { RootState } from "@redux/store";
import { getVoiceCallStartData } from "@services/voice-call/voiceCallService";
import moment from "moment";
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";

interface IUseVoiceTimerProps
{
    config: IVoiceTimer,
    voiceCallId?: string | null
}

export const useVoicetimer = (props: IUseVoiceTimerProps) => {
    const { voiceCallId } = props
    const [time, setTime] = useState<IVoiceTimer>(props.config)
    const [callId, setCallId] = useState<string | null>(null)
    const [expired, setExpired] = useState<boolean>(false)
    const [started, setStarted] = useState<boolean>(false)
    const currentCall = useSelector((state: RootState) => state.voiceCall)
    const [showTimer, setShowTimer] = useState(false)
    // Note: For tests
    // const [startCallTime, setStartCallTime] = useState("")

    const tick = (tempTime: IVoiceTimer): IVoiceTimer | null => {
        // console.debug("Tick time", tempTime)
        if (tempTime.hours <= 0 && tempTime.minutes <= 0 && tempTime.seconds <= 0) { // end countdown 
            // reset()
            setExpired(true)
            return null
        }
        else if (tempTime.minutes <= 0 && tempTime.seconds <= 0) {// subtract hours
            console.log("time2 subtract hours", tempTime)
            return {
                hours: tempTime.hours - 1 , 
                minutes: 59, 
                seconds: 59
            };
        }
        else if (tempTime.hours <= 0 && tempTime.seconds <= 0) {// subtract minutes
            console.log("time2 subtract minutes", tempTime)
            return {
                hours: 0, 
                minutes: tempTime.minutes - 1, 
                seconds: 59
            };
        } else if (tempTime.seconds <= 0) {
            console.debug("time3", tempTime)
            return {hours: tempTime.hours, minutes: tempTime.minutes - 1, seconds: 59};
        } else { // subtract seconds
            console.log("time4 subtract seconds")
            if(tempTime.hours === 0 && tempTime.minutes <= 2 && tempTime.seconds <= 30){
                setShowTimer(true)
            }
            return {hours: tempTime.hours, minutes: tempTime.minutes, seconds: tempTime.seconds - 1};
        }
    };

    const calculateDiff = (initialDate: Date, endDate: Date) => {
        const then = moment(initialDate)
        const now = moment(endDate)
        const duration = moment.duration(now.diff(then))
        const timeDif = moment.utc(duration.asMilliseconds()).format("HH:mm:ss").split(":")
        const currentTimeCall: IVoiceTimer = { hours: Number(timeDif[0]), minutes: Number(timeDif[1]), seconds: Number(timeDif[2]) }
        const timeLeft: IVoiceTimer = { hours: time.hours - currentTimeCall.hours, minutes: time.minutes - currentTimeCall.minutes, seconds: time.seconds - currentTimeCall.seconds}
        return timeLeft
    }

    useEffect(() => 
    {
        if(voiceCallId)
        {
            setCallId(voiceCallId)
            return
        }

        if(currentCall.call?.id)
        {
            setCallId(currentCall.call.room)
            return
        }

        setCallId(null)
        setStarted(false)
    }, [currentCall, voiceCallId])

    useEffect(() => {
        if(!callId) return
        if(!currentCall?.call?.room) return
        if(!currentCall?.answered) return
        const timeout = setTimeout(() => {
            if(!currentCall?.call?.room) return
            if(!currentCall?.answered) return
            // Fetch the current call start date
            getVoiceCallStartData(currentCall.call.room)
                .then(result => {
                    const now = new Date(result.start_time)
                    // Note: For tests
                    // const startCall = dayjs(now).format("YYYY-MM-DDTHH:mm:ssZ[Z]")
                    // setStartCallTime(startCall)
                    const timeLeft = calculateDiff(now, new Date())
                    setTime(timeLeft)
                    setStarted(true)
                    setExpired(false)
                })
                .catch((err) => {
                    console.error("getVoiceCallStartData", err)
                });
        }, 1500)

        return () => {
            if(timeout)
                clearTimeout(timeout)
        }
        // eslint-disable-next-line
    }, [callId, currentCall.answered]);

    // Note: For tests
    // useEffect(() => {
    //     console.log("startCallTime:: ", startCallTime)
    //     console.log("time:: ", time)
    // }, [startCallTime, time])

    useEffect(() => {
        let timeout: NodeJS.Timeout | null = null
        if(started && !expired)
        {
            let tempTime: IVoiceTimer | null = time
            timeout = setInterval(() => {
                if(tempTime)
                    tempTime = tick(tempTime)
                if(tempTime)
                {
                    setTime(tempTime)
                }
            }, 1000)
        }
    
        return () => {
            if(timeout) clearInterval(timeout)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [started, expired])

    const resetStates = () => {
        setTime(props.config)
        setCallId(null)
        setExpired(false)
        setStarted(false)
        setShowTimer(false)
        // setStartCallTime("")
    }

    return { time, showTimer, expired, resetStates }
}
